import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Cache-bust via unique query param on every GET so any CDN/proxy in front
  // of the backend cannot serve a stale cached body to authenticated callers.
  // (We intentionally do NOT add a Cache-Control request header — that triggers
  // a CORS preflight that some proxy setups silently reject when credentials
  // are involved.)
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _: Date.now() };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("tc_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    if (err?.response?.status === 402) {
      window.dispatchEvent(new Event("cj-ai-check"));
    }
    return Promise.reject(err);
  }
);

export default api;

// helper to build authenticated file URLs (for <img src>/<video src>)
export const fileUrl = (storagePath) => {
  const token = localStorage.getItem("tc_token");
  if (!storagePath) return "";
  return `${API_BASE}/files/${storagePath}?auth=${encodeURIComponent(token || "")}`;
};

// avatar: prefer uploaded path (proxied via file URL w/ viewer token), fall back to stock avatar_url
export const avatarSrc = (u) => {
  if (!u) return "";
  if (u.avatar_path) return fileUrl(u.avatar_path);
  return u.avatar_url || "";
};
